import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { NgbModalOptions, NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Workspace } from "../../../model/workspace.data";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { IParameters } from "../../../interfaces/IParameters";
import * as $ from "jquery";

import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { strategyCellRendererComponent } from "../../../renderers/strategyCellRendererComponent.component";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { callNextAsync } from "../../../services/BaseService";
import { IPreviousChallengesResponse, historyChallenge } from "../../../interfaces/service.response";

@Component({
    selector: "challengesHistory",
    template: require('./challengesHistory.component.html'),
    styles: [require('./challengesHistory.component.css')]
})
export class challengesHistoryComponent extends AppComponentBase implements OnInit, AfterViewInit {
   
    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        private globalGridModeService: GlobalGridModeService,
        private ngbModalService: NgbModal
    ) {
        super(injector);

        this.sendRequest()

        this.dataService.dataSubscriber.subscribe(response => {
            if (response.Type == "PreviousChallengesResponse") {
             
                var PreviousChallengesResponse: IPreviousChallengesResponse = <IPreviousChallengesResponse>response;

                
                this.previousChallenges = PreviousChallengesResponse.Challenges;

                if(this.selectAcccount==-1)
                {
                     this.selectAcccount = this.previousChallenges[0].AccountId;
                     let findAccount = this.workspace.allAccount.find(a => a.id == this.selectAcccount);

                     if(findAccount!==undefined)
                     {
                          this.workspace.selectedChallengeHistoryAccInfo = {
                        id : this.selectAcccount,
                        name : findAccount.accountName
                        }
                     }
                    
                }
               

            }
        })
    }

    private _selectAcccount: number = -1;
    public get selectAcccount (): number {
        return this._selectAcccount;
    }
    public set selectAcccount ( value: number ) {
        this._selectAcccount = value;

            let findAccount = this.workspace.allAccount.find(a => a.id == this.selectAcccount);

            if(findAccount!==undefined)
            {
                this.workspace.selectedChallengeHistoryAccInfo = {
                id : this.selectAcccount,
                name : findAccount.accountName
                }
            }




        setTimeout(() => {
             this.workspace.sendPreviousChallengesHistoryRequest(value);
        }, 500);
       
    }

    private _previousChallenges: historyChallenge[] = [];
    public get previousChallenges (): historyChallenge[] {
        return this._previousChallenges;
    }
    public set previousChallenges ( value: historyChallenge[] ) {
        this._previousChallenges = value;
    }


    ifNotEmptyGetValue(value: string | undefined, defaultValue: string) {
        return value && value.trim() != "" ? value : defaultValue;
    }

    ngOnInit() {}
    ngAfterViewInit(): void {
        //   $(".container-strategies").mCustomScrollbar({
        //     axis: "y",
        //     theme: "inset-3", // "minimal-dark",
        //     scrollbarPosition: "outside",
        //     alwaysShowScrollbar: 1, // 0,1,2
        //     scrollButtons: {
        //         enable: true
        //     },
        //     mouseWheel: {
        //         enable: true
        //     }
        // });
    }

    public sendRequest()
    {
        this.workspace.sendPreviousChallengesRequest()
        
    }
    
}

export function challengesHistoryModal(modalService: NgbModal){
    let m:NgbModalRef= modalService.open(challengesHistoryComponent,{
        backdrop: "static",
        size: "lg",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<challengesHistoryComponent>m.componentInstance);

}
